import { render, staticRenderFns } from "./cameraSetttingSidebarView.vue?vue&type=template&id=37642d94&scoped=true&"
import script from "./cameraSetttingSidebarView.vue?vue&type=script&lang=js&"
export * from "./cameraSetttingSidebarView.vue?vue&type=script&lang=js&"
import style0 from "./cameraSetttingSidebarView.vue?vue&type=style&index=0&id=37642d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37642d94",
  null
  
)

export default component.exports